import { BehaviorSubject } from 'rxjs';

import { Injectable } from '@angular/core';
import { ContentService } from '@core/services/content.service';
import { PageViewModel } from '@models/api.models';

@Injectable({
    providedIn: 'root'
})
export class FilterNavigationService {
    private navigationBs = new BehaviorSubject<PageViewModel>({});
    private rootId: string = '';
    public navigation$ = this.navigationBs.asObservable();

    constructor(private contentService: ContentService) {}

    public setNavigation(hierachyRootId: string, maxLevel = 10): void {
        if (this.rootId === hierachyRootId) {
            return;
        }

        this.rootId = hierachyRootId;

        this.contentService
            .getCategoryNavigationContent(hierachyRootId, { maxLevel })
            .subscribe(response => this.navigationBs.next(response));
    }

    public destroy(): void {
        this.navigationBs.next({});
    }
}
